import { useEffect, useRef, useState } from 'react'

interface UseIntersectionObserverProps {
  threshold?: number
  rootMargin?: string
  onIntersect?: () => void
  enabled?: boolean
}

export function useIntersectionObserver({
  threshold = 0.1,
  rootMargin = '100px',
  onIntersect,
  enabled = true
}: UseIntersectionObserverProps) {
  const [isIntersecting, setIsIntersecting] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!enabled) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting)
        if (entry.isIntersecting && onIntersect) {
          onIntersect()
        }
      },
      { threshold, rootMargin }
    )

    const element = ref.current
    if (element) {
      observer.observe(element)
    }

    return () => {
      if (element) {
        observer.unobserve(element)
      }
    }
  }, [threshold, rootMargin, onIntersect, enabled])

  return { ref, isIntersecting }
}

